import React from "react";
import InternshipForm from "../component/Internship/InternshipForm";
import { FaUserGraduate, FaGavel, FaFileAlt } from "react-icons/fa";

export default function Internship() {
  return (
    <div className="min-h-screen w-full bg-white text-[#0F172A]">
      {/* Hero Section */}
      <div className="relative h-[50vh] flex flex-col items-center justify-center text-center bg-[#0F172A] text-white p-6">
        <h1 className="text-4xl font-extrabold text-[#CFAF5A] drop-shadow-lg">
          Legal Internship Program
        </h1>
        <p className="text-lg mt-4 max-w-2xl text-gray-300">
          Gain hands-on experience in a professional legal environment. Work on
          real cases and develop your career under expert guidance.
        </p>
      </div>

      {/* Details Section */}
      <section className="max-w-5xl mx-auto px-6 py-12 grid md:grid-cols-3 gap-8">
        <div className="p-6 bg-[#EAEAEA] rounded-lg shadow-lg border border-gray-300 text-center">
          <FaUserGraduate className="text-3xl text-[#CFAF5A] mx-auto" />
          <h3 className="text-xl font-semibold mt-4">Who Can Apply?</h3>
          <p className="text-gray-700 mt-2 text-sm">
            Law students in their 3rd year or final year (5-year/3-year course).
          </p>
        </div>
        <div className="p-6 bg-[#EAEAEA] rounded-lg shadow-lg border border-gray-300 text-center">
          <FaGavel className="text-3xl text-[#CFAF5A] mx-auto" />
          <h3 className="text-xl font-semibold mt-4">What We Offer?</h3>
          <p className="text-gray-700 mt-2 text-sm">
            Exposure to legal cases, mentorship, court visits, and certification.
          </p>
        </div>
        <div className="p-6 bg-[#EAEAEA] rounded-lg shadow-lg border border-gray-300 text-center">
          <FaFileAlt className="text-3xl text-[#CFAF5A] mx-auto" />
          <h3 className="text-xl font-semibold mt-4">How to Apply?</h3>
          <p className="text-gray-700 mt-2 text-sm">
            Fill out the form below and submit your resume.
          </p>
        </div>
      </section>

      {/* Application Form Section */}
      <section
        id="apply"
        className="max-w-3xl mx-auto  py-12 bg-[#F8F9FA] rounded-lg shadow-lg border border-gray-300"
      >
        <h2 className="text-2xl font-semibold text-center text-[#CFAF5A]">
          Apply Now !
        </h2>
        <InternshipForm />
      </section>
    </div>
  );
}